var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 18.3869,
    rx: 18,
    ry: 18.0705,
    fill: "#E83647"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4183 24.4103C15.1524 24.4103 14.9086 24.3177 14.7091 24.1094L10.2992 19.5035C9.90028 19.0869 9.90028 18.4389 10.2992 18.0223C10.6981 17.6056 11.3186 17.6056 11.7175 18.0223L15.4404 21.8875L24.2825 12.6757C24.6814 12.2591 25.3019 12.2591 25.7008 12.6757C26.0997 13.0924 26.0997 13.7404 25.7008 14.157L16.1496 24.1094C15.928 24.3177 15.6842 24.4103 15.4183 24.4103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4183 24.4103C15.1524 24.4103 14.9086 24.3177 14.7091 24.1094L10.2992 19.5035C9.90028 19.0869 9.90028 18.4389 10.2992 18.0223C10.6981 17.6056 11.3186 17.6056 11.7175 18.0223L15.4404 21.8875L24.2825 12.6757C24.6814 12.2591 25.3019 12.2591 25.7008 12.6757C26.0997 13.0924 26.0997 13.7404 25.7008 14.157L16.1496 24.1094C15.928 24.3177 15.6842 24.4103 15.4183 24.4103Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.718c6ce6b30f1db210e97614596e2585.svg";
export { ForwardRef as ReactComponent };